import type { BulkEditColumnId } from './bulk-edit.types';
import { ALL_BULK_EDIT_STATIC_COLUMN_IDS } from './bulk-edit.types';

export const BULK_EDIT_ROW_PX = 52;
export const BULK_EDIT_HEADER_PX = 40;
export const BULK_EDIT_CHECKBOX_PX = 44;
export const BULK_EDIT_PRODUCT_PX = 380;
export const BULK_EDIT_LEFT_PX = BULK_EDIT_CHECKBOX_PX + BULK_EDIT_PRODUCT_PX;

export type BulkEditFieldAlign = 'left' | 'right' | 'center';

export interface BulkEditDataColumn {
  id: BulkEditColumnId;
  width: number;
  align: BulkEditFieldAlign;
}

export const BULK_EDIT_DATA_COLUMNS: BulkEditDataColumn[] = [
  { id: 'description', width: 200, align: 'left' },
  { id: 'unitLabel', width: 120, align: 'left' },
  { id: 'accountingCode', width: 140, align: 'left' },
  { id: 'mappedTaxCategory', width: 148, align: 'left' },
  { id: 'price', width: 168, align: 'right' },
  { id: 'creditPrice', width: 110, align: 'right' },
  { id: 'sku', width: 160, align: 'left' },
  { id: 'weight', width: 100, align: 'right' },
  { id: 'status', width: 132, align: 'left' },
  { id: 'stock', width: 132, align: 'left' },
  { id: 'default', width: 120, align: 'left' },
  { id: 'recurring', width: 120, align: 'left' },
  { id: 'interval', width: 120, align: 'left' },
  { id: 'intervalCount', width: 100, align: 'right' },
  { id: 'shippable', width: 120, align: 'left' },
  { id: 'taxable', width: 120, align: 'left' },
  { id: 'sync', width: 120, align: 'left' },
];

/** Preserve column order from ALL_BULK_EDIT_STATIC_COLUMN_IDS + price placement. */
const COLUMN_BY_ID = new Map(BULK_EDIT_DATA_COLUMNS.map((col) => [col.id, col]));

export function buildAllDataColumns(): BulkEditDataColumn[] {
  return ALL_BULK_EDIT_STATIC_COLUMN_IDS.map((id) => COLUMN_BY_ID.get(id)!);
}

export function getVisibleDataColumns(visible: Set<BulkEditColumnId>): BulkEditDataColumn[] {
  return buildAllDataColumns().filter((col) => visible.has(col.id));
}

export function getDataGridMinWidth(visible: Set<BulkEditColumnId>): number {
  return getVisibleDataColumns(visible).reduce((sum, col) => sum + col.width, 0);
}
